<template>
  <div class="cooperation_box">
    <section class="w3l-newsletter">
      <div class="form-25-main py-5">
        <div class="container py-lg-5">
          <div class="forms-25-info">
            <div class="mb-md-5 mt-4">
              <div class="coo">战略合作企业</div>
            </div>
            <div class="row">
              <!-- <span
                v-for="(item, index) in cooList"
                :key="index"
                class="item"

                placement="top"
              > -->
                <div  v-for="(item, index) in cooList"
                :key="index" class="col-xs-6 col-md-2">
                  <a href="javascript:void(0)" class="thumbnail">
                    <img :src="item.picUrl" alt="..." />
                  </a>
                </div>
              <!-- </span> -->
            </div>

            <div class="readhny-btm text-center mx-auto mt-md-4">
              <router-link
              class="btn btn-primary btn-style mt-md-5 mt-4"
              to="/about"
            >
              了解我们
              <span class="fa fa-chevron-right ml-2" aria-hidden="true"></span>
            </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {cooperationList} from "@/api/cooperation/index"
export default {
  data() {
    return {
      cooList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 24,
        picType:1,
        status:0
      },
    };
  },
  mounted(){
    this.getCooperationData()
  },
  methods:{
    getCooperationData(){
        cooperationList(this.queryParams).then(res => {
          this.cooList = res.rows
        })
    }
  },
  
};
</script>

<style lang="less" scoped>
.coo {
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 26px;
}

.col-md-2 {
  margin-bottom: 20px;
  text-align: center;
  line-height: 68px;
}

/* 去色 */
// .thumbnail img {
//   width: 60%;
//   -webkit-filter: grayscale(100%);
//   -moz-filter: grayscale(100%);
//   -ms-filter: grayscale(100%);
//   -o-filter: grayscale(100%);
//   filter: grayscale(100%);
//   filter: gray;
// }

// .thumbnail img:hover {
//   filter: grayscale(0);
//   filter: none;
// }
.item{
  float: left;
}
</style>>
